module.exports = __webpack_public_path__ + "static/media/web.2e8683b7.svg";